import { httpRequest } from "../../../http";

export interface CheckConnectionResponse {
  connected: boolean;
  /** Why the check failed. The network's own message, worth showing verbatim. */
  error?: string | null;
}

export class CommandCheckConnection {
  async run(resourceId: number): Promise<CheckConnectionResponse> {
    try {
      const response = await httpRequest<CheckConnectionResponse>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/resources/${resourceId}/check-connection/`,
        { method: "POST" },
      );
      return response;
    } catch (error) {
      console.error("Error checking connection:", error);
      throw error;
    }
  }
}
